import { Action } from 'redux';

import { UpdateBreadcrumbs } from '~src/bootstrap/redux/actions/AppActionTypes';
import { isActionFactory } from '~src/bootstrap/redux/actions/isActionFactory';

import { BreadcrumbStateInfo } from '../components/breadcrumbs/BreadcrumbStateInfo';

export interface UpdateBreadcrumbsAction extends  Action {
  breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>;
}

export function updateBreadcrumbs(breadcrumbs: ReadonlyArray<BreadcrumbStateInfo>): UpdateBreadcrumbsAction {
  return {
    type: UpdateBreadcrumbs,
    breadcrumbs
  };
}

export const isUpdateBreadcrumbsAction = isActionFactory<UpdateBreadcrumbsAction>(UpdateBreadcrumbs);
